import {
  TilePacketTransport,
  TilePacketTransportOptions,
  TilePacketTransportMessage,
  TilePacketTransportListener,
} from '@apptile/tile-packet-sdk';

export function createTilePacketWorkerTransport(
  testTransport: 'tile-packetpub' | 'trafficMirroring',
  options: TilePacketTransportOptions,
) {
  let transport: TilePacketTransport | null = null;
  function getTransport(): TilePacketTransport {
    if (!transport) {
      const worker = new Worker(new URL('@/workers/transport.worker.ts', import.meta.url));
      worker.postMessage({ type: 'init', data: options, testTransport });
      transport = worker;
    }
    return transport;
  }
  let transportListener: ((event: any) => void) | undefined;
  return {
    addEventListener: (type: 'message', listener: TilePacketTransportListener) => {
      if (!transportListener) {
        transportListener = (event: any) => {
          const message = event.data;
          listener(message);
        };
      }
      getTransport().addEventListener(type, transportListener);
    },
    removeEventListener: (type: 'message', _listener: TilePacketTransportListener) => {
      if (transportListener) {
        transport?.removeEventListener(type, transportListener);
        transportListener = undefined;
      }
    },
    postMessage: (message: TilePacketTransportMessage) => getTransport().postMessage(message),
  };
}
